"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const state_1 = require("@airstudio/state");
const react_redux_1 = require("react-redux");
const JsonViewer_1 = require("../JsonViewer");
const resourceQuery_1 = require("../../hooks/resourceQuery");
const workspace_1 = require("../../hooks/workspace");
exports.Resource = ({ path, id, componentClass: CC }) => {
    const { resource, isProcessing, errorMessage, } = resourceQuery_1.useResourceQuery({ path, id });
    const [isEditable, setIsEditable] = react_1.useState(false);
    const [draftItem, setDraftItem] = react_1.useState({});
    const history = react_router_dom_1.useHistory();
    const workspaceId = workspace_1.useWorkspace();
    const dispatch = react_redux_1.useDispatch();
    const dispatchUpdateEntity = state_1.Operations.Entities.save(dispatch);
    react_1.useEffect(() => {
        if (id === '_') {
            setIsEditable(true);
            setDraftItem({});
        }
        else {
            setDraftItem(resource);
        }
    }, [id]);
    const handleSave = async (attributes) => {
        const itemId = id !== '_' ? id : undefined;
        const newIdCallback = (newId) => {
            if (newId !== id) {
                history.push(`${path}/${newId}`);
            }
        };
        const isSuccess = await dispatchUpdateEntity(workspaceId, path, attributes || draftItem, itemId, newIdCallback);
        if (isSuccess) {
            setIsEditable(false);
        }
        return isSuccess;
    };
    if (!resource && isEditable) {
        return react_1.default.createElement("div", null);
    }
    return CC
        ? (react_1.default.createElement(CC, { resource: resource, handleSave: handleSave, isEditable: isEditable, draftItem: draftItem, setDraftItem: setDraftItem, isProcessing: isProcessing, errorMessage: errorMessage }))
        : react_1.default.createElement(JsonViewer_1.JsonViewer, { json: { resource } });
};
//# sourceMappingURL=index.js.map